import { Box, TextField } from "@mui/material";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import toast from "react-hot-toast";
import { ENVIO_ESTADO_AUTORIZADO_ID, ENVIO_ESTADO_AUTORIZAR_ID } from "./useEnvioCreationContentInputs";

export function useInsumoSectionColumns(
  setInsumosRows,
  isActualizarStockRequired,
  disabledNormalInput,
  initialEnvioEstado
) {
  const handleChange = (id, idInsumo, value, stockDisponibleDeposito, cuotaActiva, saldo) => {

    if (isActualizarStockRequired) return toast.error('Se requiere actualizar el stock');

    value = parseInt(value);
    if (isNaN(value)) return;
    if (value < 0) return toast.error('La cantidad a pedir no puede ser menor a 0');
    if (value > stockDisponibleDeposito) {
      return toast.error('La cantidad a pedir no puede ser mayor al stock disponible en el depósito');
    }
    if (cuotaActiva === "SI" && value > saldo) {
      return toast.error('La cantidad a pedir no puede ser mayor al saldo si hay cuota activa');
    }

    setInsumosRows((prevRows) => {
      const newRows = [...prevRows];
      if (newRows[id - 1]) {
        newRows[id - 1] = { ...newRows[id - 1], cantidadAPedir: String(value) };
      }
      return newRows;
    });
    // setInsumosRows((prevRows) =>
    //   prevRows.map((row) =>
    //     row.idInsumo === idInsumo ? { ...row, cantidadAPedir: value.toString() } : row
    //   )
    // );
  };

  const detalleInsumoInitialColumns = [
    { field: "idInsumo", headerName: "ID insumo", flex: 90 },
    { field: "descripcion", headerName: "Descripción", flex: 197 },
    { field: "por", headerName: "Por", flex: 25 },
    { field: "cantidadPlan", headerName: "Cant. Plan", flex: 100 },
    { field: "cantidadDiaria", headerName: "Cant. Diaria", flex: 100 },
    {
      field: "stockDisponibleDeposito",
      headerName: "Stock Disp. Depo.",
      flex: 130,
    },
    { field: "cuotaActiva", headerName: "Cuota Activa", flex: 100 },
    { field: "cantidadCuota", headerName: "Cant. Cuota", flex: 100 },
    { field: "saldo", headerName: "Saldo", flex: 100 },
    {
      field: "cantidadAPedir",
      headerName: "Cant. a Pedir",
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <TextField
              type="number"
              variant="outlined"
              value={row.cantidadAPedir || ""}
              onChange={(e) =>
                handleChange(row.id, row.idInsumo, e.target.value, row.stockDisponibleDeposito, row.cuotaActiva, row.saldo)
              }
              disabled={disabledNormalInput || initialEnvioEstado === ENVIO_ESTADO_AUTORIZADO_ID}
              sx={{
                borderRadius: "5px",
                "& .MuiOutlinedInput-input": {
                  padding: "5px 10px !important",
                },
              }}
            />
          </Box>
        );
      },
    },
  ];

  const detalleInsumoColumns = generateColumnsDefaultConfiguration(
    detalleInsumoInitialColumns,
    true
  );

  return detalleInsumoColumns;
}
